import {
  formatDistanceToNow,
  format,
  isBefore,
  isAfter,
  parseISO,
  addDays
} from "date-fns";

type Value = number | Date | string;

const RELATIVE_CUT_OFF = 31; // (i.e approximately 1 month)

export const parseDate = (value: Value): Date | number =>
  typeof value === "string" ? parseISO(value) : value;

const formatDate = {
  relative: (value: Value) => {
    if (!value) return "";
    const date = parseDate(value);
    const overdue = isBefore(date, Date.now());

    // If the date exceeds the number of days before/after
    // RELATIVE_CUT_OFF, we return a condensed date
    // instead of a relative date
    const isOutsideRelativeRange = overdue
      ? isBefore(date, addDays(Date.now(), RELATIVE_CUT_OFF))
      : isAfter(date, addDays(Date.now(), RELATIVE_CUT_OFF));

    if (isOutsideRelativeRange) {
      return format(parseDate(date), "dd/MM/yyyy");
    }

    const relativeTime = formatDistanceToNow(date);
    return overdue ? `${relativeTime} ago` : `in ${relativeTime}`;
  },
  fullText: (value: Value) =>
    value ? format(parseDate(value), "EEEE, do MMMM yyyy") : "",
  condensed: (value: Value) =>
    value ? format(parseDate(value), "dd/MM/yyyy") : ""
};

export default formatDate;
